import React, {PureComponent, Fragment} from 'react'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import Collapse from '@material-ui/core/Collapse';

export class OptionOrTextField extends PureComponent {
  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array
  }

  handleChange = event => {
    this.props.onChange && this.props.onChange({target: {value: event.target.value}})
  }

  get radioValue() {
    const {options, value} = this.props
    return options.includes(value) ? value : ''
  }

  render = () => {
    const {className, styles, name, disabled, options, value, label} = this.props
    return (
      <Fragment>
        <RadioGroup name={name} className={className} styles={styles} onChange={this.handleChange} value={this.radioValue}>
          {options.map(option =>
            <FormControlLabel key={option} value={option} control={<Radio disabled={disabled}/>} label={option} />
          )}
          <FormControlLabel value="" control={<Radio disabled={disabled}/>} label="Other" />
        </RadioGroup>
        <Collapse in={this.radioValue === ''}>
          <TextField label={label} value={value} onChange={this.handleChange} />
        </Collapse>
      </Fragment>
    )
  }
}

export default OptionOrTextField